export default __webpack_public_path__ + "b0d9d85d4578e7ab26d90950de50fe1c.ttf";